import React, { useState } from 'react';
import AddDriverModal from '../../AddLoads/AddDriverModal';
import DispatchModal from '../../AddLoads/DispatchModal';
import { CustomButton } from '../../_common/';
import { useStoreContext } from '../../App/StoreProvider';
import * as Actions from '../../../store/actions/addLoadModal';
import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';
import { useQuery } from '@apollo/client/react';

interface AssignDriverModalProps {
    jobId: number | null | undefined;
    regionId: number;
    loadId: number;
    proppantName: string;
    lofa: string;
    lofaId: number;
    isFromLoads: boolean;
    isSplitLoad: boolean;
    sandPO?: string;
    driverName?: string;
    jobName?: string;
    refetch?: () => void;
}

const AssignDriverModal = ({
    jobId,
    regionId,
    loadId,
    proppantName,
    lofa,
    lofaId,
    isFromLoads,
    isSplitLoad,
    sandPO,
    driverName,
    jobName,
    refetch,
}: AssignDriverModalProps): React.ReactElement => {
    const canAddDriver = useAuthContext().userHasPermission(PermissionEnum.ManageLoads);
    const [showAssignDriverModal, setShowAssignDriverModal] = useState(false);
    const [showDispatchModal, setDispatchModal] = useState(false);
    const [, dispatch] = useStoreContext();
    const handleClickBack = (): void => {
        setShowAssignDriverModal(false);
        setDispatchModal(true);
    };
    const handleOnClickHide = (): void => {
        setShowAssignDriverModal(false);
    };

    const region = {
        id: regionId,
        regionName: '',
        extSystemName: '',
        extSystemReference: '',
        regionCode: '',
    };

    const handleClickHide = (): void => {
        if (refetch) {
            refetch();
        }
        setDispatchModal(false);
    };

    // let { data: standbyDriverData, refetch: standByDriversRefetch } = useQuery(GET_STANDBY_DRIVERS, {
    //     variables: {
    //         jobId: jobId,
    //     },
    //     fetchPolicy: 'network-only',
    //     pollInterval: 300000,
    // });

    // if (standByDriversRefetch) {
    //     standByDriversRefetch();
    // }

    // let standbyDrivers: standByDrivers[] = [];
    // if (standbyDriverData && standbyDriverData.getStandbyDrivers && standbyDriverData.getStandbyDrivers.length !== 0) {
    //     standbyDriverData.getStandbyDrivers.forEach((element: standByDrivers | null): void => {
    //         if (element !== null) {
    //             standbyDrivers.push(element);
    //         }
    //     });
    // }

    return (
        <React.Fragment>
            <CustomButton
                title="Assign Driver"
                isBordered
                onClick={(): void => {
                    setShowAssignDriverModal(true);
                    dispatch(Actions.setCurrentLoadId(loadId));
                    dispatch(Actions.setCreatedLoadIds([loadId]));
                }}
                isDisabled={!canAddDriver}
            />
            {showAssignDriverModal && (
                <AddDriverModal
                    jobId={jobId}
                    show={showAssignDriverModal}
                    onClickBack={handleClickBack}
                    onClickHide={handleOnClickHide}
                    region={region}
                    wellhead={jobName}
                    load={String(loadId)}
                    proppantName={proppantName}
                    lofa={lofa}
                    lofaId={lofaId}
                    isFromLoads={isFromLoads}
                    isSplitLoad={isSplitLoad}
                    sandPO={sandPO}
                    driverName={driverName}
                />
            )}
            <DispatchModal
                isFromLoads={isFromLoads}
                isSplitLoad={isSplitLoad}
                show={showDispatchModal}
                onClickHide={handleClickHide}
            />
        </React.Fragment>
    );
};

export default AssignDriverModal;
